import React from 'react';
import { TableRow, TableCell, Tooltip, Typography } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Badge from '../../shared_components/components/Badge';
import { INVOICE_STATUS_COLOR } from '../constants';
import { formatTrackerDate, planDurationDays } from '../utils';
import { TEXT, TruncatedText } from '../../shared_components';

const ClosedRow = ({ plan, onView, onRaiseInvoice, onMarkPaid }) => {
  const invoiceStatusLabel = plan?.invoice_status?.label || 'Not Raised';
  const closedDate = plan?.client_acceptance_date || plan?.closed_at;
  const durationDays = planDurationDays(plan);
  return (
    <TableRow hover>
      <TableCell><Typography variant="body2" style={{ fontWeight: 600, color: TEXT.primary }}><TruncatedText text={plan?.name} maxWidth={240} /></Typography></TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}><TruncatedText text={plan?.lessor?.name} maxWidth={160} /></Typography></TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{formatTrackerDate(closedDate)}</Typography></TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{durationDays != null ? `${durationDays} days` : '--'}</Typography></TableCell>
      <TableCell><Badge label={invoiceStatusLabel} color={INVOICE_STATUS_COLOR[invoiceStatusLabel]} /></TableCell>
      <TableCell align="right">
        <Tooltip title="View" arrow>
          <VisibilityIcon color="primary" fontSize="small" style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => onView(plan)} />
        </Tooltip>
        {/* {invoiceStatusLabel !== 'Financially Closed' ? (
          <Tooltip title={invoiceStatusLabel === 'Not Raised' ? 'Raise Invoice' : 'Mark Paid'} arrow>
            <ReceiptIcon
              color="primary" fontSize="small" style={{ cursor: 'pointer' }}
              onClick={() => (invoiceStatusLabel === 'Not Raised' ? onRaiseInvoice(plan) : onMarkPaid(plan))}
            />
          </Tooltip>
        ) : null} */}
      </TableCell>
    </TableRow>
  );
};

export default ClosedRow;
